import React from 'react';
function Download({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 15v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3M7 10l5 5 5-5M12 15V4"
      />
    </svg>
  );
}

export default Download;
